export const pages = [
  {
    page: 1,
    question: "Как  экологичнее попрощаться со старой щёткой?",
    variants: [
      {
        value: 0,
        title: "просто выбросить",
      },
      {
        value: 0,
        title: "разломать и выбросить",
      },
      {
        value: 0,
        title: "отделить щетинки от ручки и так выбросить в мусорное ведро",
      },
      {
        value: 1,
        title: "сдать на переработку целиком",
      },
    ],
  },
  {
    page: 2,
    question: "Какие щётки мы принимаем в рамках нашей акции по переработке?",
    variants: [
      {
        value: 0,
        title: "деревянные",
      },
      {
        value: 1,
        title: "пластиковые",
      },
      {
        value: 0,
        title: "электрические",
      },
      {
        value: 0,
        title: "все",
      },
    ],
  },
  {
    page: 0,
    result: (<div className="test-result">К сожалению, мы пока принимаем только пластиковые щётки, а деревянные и электрические можно сдать в пункты переработки в вашем городе. Смотрите адреса на <a href="https://recyclemap.ru/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>recyclemap.ru</a></div>)
  },
  {
    page: 3,
    question: "После переработки старые щётки мы превращаем в....?",
    variants: [
      {
        value: 0,
        title: "новые щётки",
      },
      {
        value: 0,
        title: "пластиковые окна",
      },
      {
        value: 1,
        title: "тротуарную плитку и бордюр",
      },
      {
        value: 0,
        title: "бордюр",
      },
    ],
  },
  {
    page: 4,
    question: "Сколько нужно щёток, чтобы сделать одну плитку?",
    variants: [
      {
        value: 0,
        title: "1",
      },
      {
        value: 0,
        title: "518",
      },
      {
        value: 0,
        title: "25",
      },
      {
        value: 1,
        title: "15",
      },
    ],
  },
  {
    page: 0,
    result: (<div className="test-result">На данный момент собрано и передано на переработку уже более 2570 кг щёток.</div>)
  },
  {
    page: 5,
    question: "Хорошо, а где уже есть новенькая плитка из щёток?",
    variants: [
      {
        value: 0,
        title: "Набережная во Владивостоке",
      },
      {
        value: 1,
        title: "Центральная площадь Окуловки",
      },
      {
        value: 0,
        title: "Парк в Москве",
      },
      {
        value: 0,
        title: "Крыша в Питере",
      },
    ],
  },
  {
    page: 0,
    result: (<div className="test-result">1680 м^2 размер центральной площади города Окуловка в Новгородской области выложенная плиткой из переработанного сырья.</div>)
  },
];
